import { useAuth } from '@saltus/auth';
import { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import debug from '../../services/debug';
import Loading from '../loading/component';

function EnforceMfa({ children }) {
  const { getPreferredMFA, user } = useAuth();
  const isCancelled = useRef(false);
  const [mfa, setMfa] = useState();
  const [groups, setGroups] = useState([]);
  const [isSPP, setIsSPP] = useState();
  const [isAzureAD, setIsAzureAD] = useState(false);
  const { pathname } = useLocation();
  const isAdviser = groups.find((group) => group === 'Adviser');

  useEffect(() => {
    debug('EnforceMfa:useEffect', { user });
    if (user) {
      isCancelled.current = false;

      setGroups(user.groups ?? []);

      setIsSPP(!!user.attributes['custom:EmployeeID']);

      setIsAzureAD(() => {
        if (user.attributes.identities) {
          const identity = JSON.parse(user.attributes.identities).find(
            (item) =>
              item?.providerType === 'SAML' &&
              item?.providerName?.endsWith('AD'),
          );

          return !!identity;
        }

        const azureAdGroup = groups.find((group) => group.endsWith('AD'));

        return !!azureAdGroup;
      });

      getPreferredMFA()
        .then((value) => {
          debug('getPreferredMFA:resolving', { value, isCancelled });
          if (!isCancelled.current) {
            setMfa(value);
          }
        })
        .catch((err) => {
          debug('getPreferredMFA:ERROR', err);
        });
    }

    return () => {
      isCancelled.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, pathname]);

  if (!mfa && !window.ReactNativeWebView) {
    return <Loading />;
  }

  if (
    !isAzureAD &&
    isAdviser &&
    isSPP &&
    mfa === 'NOMFA' &&
    !pathname.startsWith('/2fa-enrolment')
  ) {
    return <Navigate to="/2fa-enrolment/" />;
  }

  return children;
}

EnforceMfa.propTypes = {
  children: PropTypes.node.isRequired,
};

export default EnforceMfa;
